/* eslint-disable no-nested-ternary */
import React from 'react';
import { animated, to } from 'react-spring';
import styled from 'styled-components';
import images from '_images';

const MaterialDetails = styled(animated.div)`
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 3%;
  background-color: white;
  max-height: 100%;
  will-change: transform;
  border-radius: 10px;
`;

const CardContainer = styled(animated.div)`
  position: absolute;
  overflow: hidden;
  width: ${({ windowsWidth }) => (windowsWidth < 400 ? '85%' : ((windowsWidth < 750 ? `${(windowsWidth * (-1 / 10) + 120)}%` : '35%')))};
  margin-top: 5px;
  margin-bottom: 5px;
  height: 50vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 10px;  
  box-shadow:
  2px 2px 10px 2px rgba(0, 0, 0, 0.2);
`;

const MaterialImage = styled.img`
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-left: 5%;
  margin-bottom: 5%;
  max-width: 100%;
  max-height: 70%;
  margin-left: auto;
  margin-right: auto;
  pointer-events: none;
`;

const MaterialName = styled.h2`
  text-align: center;
  font-size: 15px;
  margin-top: 1%;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
`;

const ButtonImage = styled.img`
  height: 6.5vh;
  width: 6.5vh;
  border-radius: 50%;
  background-color: #efefef;
  background-size: contain;
  background-position: center;
  margin: 0 auto;
  box-sizing: content-box;
  user-drag: none;
`;

/**
 * This component includes name and image of a material in a card with two buttons
 * for selecting recyclable or not recycable options
 * Also this component includes a function for transformation while user swipe ot to roght or left
 *
 */

const Card = ({
  i, x, y, rot, scale, trans, bind, objs, onSwipeRight, onSwipeLeft, windowsWidth
}) => {
  const { mat_nm, mat_image } = objs[i];

  return (
    <CardContainer
      windowsWidth={windowsWidth}
      key={i}
      style={{
        transform: to(
          [x, y],
          // eslint-disable-next-line no-shadow
          (x, y) => `translate3d(${x}px,${y}px,0)`
        ),
        display: 'flex'
      }}
    >
      <MaterialDetails
        {...bind(i)}
      >
        <MaterialImage
          src={mat_image}
          alt={`${mat_nm || 'Material'} image`}
        />
        <MaterialName>{mat_nm}</MaterialName>
        <ButtonsContainer>
          <ButtonImage
            src={images.recycleRight.decline}
            onClick={onSwipeLeft}
            alt="Not recyclable button"
          />
          <ButtonImage
            src={images.recycleRight.recycable}
            onClick={onSwipeRight}
            alt="Recyclable button"
          />
        </ButtonsContainer>
      </MaterialDetails>
    </CardContainer>
  );
};

export default Card;
